// Dependencies
import { createFileRoute } from "@tanstack/react-router";
import { PageShell, PageHero } from "@/components/PageShell";
import { CategoryProductGrid } from "@/components/CategoryProductGrid";
import { useTranslation } from "react-i18next";
import i18n from "@/i18n";

// Images
import propulsionPng from "@/assets/propulsion.png";
import chemicalsPng from "@/assets/chemicals.png";
import electronicPng from "@/assets/eletronic.png";
import cubesatsPng from "@/assets/cubesats.png";
import heroVideo from "@/assets/video/slow-motion-pururucaV3.mp4";

export const Route = createFileRoute("/$lang/products/")({
  head: () => ({
    meta: [
      { title: i18n.t("products/index:metaTitle", "Products — BIZU Space") },
      {
        name: "description",
        content: i18n.t("products/index:metaDesc",
          "BIZU Space products — propulsion systems, chemicals, electronic systems and CubeSat deployer systems.",
        ),
      },
      { property: "og:title", content: i18n.t("products/index:metaTitle", "Products — BIZU Space") },
      {
        property: "og:description",
        content: i18n.t("products/index:metaOgDesc",
          "Propulsion systems, chemicals, electronic systems and CubeSat deployers.",
        ),
      },
      { property: "og:url", content: "/products" },
    ],
    links: [{ rel: "canonical", href: "https://bizu.space/products" }],
  }),
  component: Products,
});

function Products() {
  const { t } = useTranslation("products/index");

  const products = [
    {
      name: t("propulsionName", "Propulsion Systems"),
      desc: t("propulsionDesc", "Advanced rocket propulsion systems for space missions, testing and operations."),
      img: propulsionPng,
      to: "/category/propulsion-systems",
    },
    {
      name: t("chemicalsName", "Chemicals"),
      desc: t("chemicalsDesc", "High-purity aerospace chemicals produced with strict quality and safety standards."),
      img: chemicalsPng,
      to: "/category/chemicals",
    },
    {
      name: t("electronicsName", "Electronic Systems"),
      desc: t("electronicsDesc", "Reliable avionics, flight computers and data acquisition systems in-house."),
      img: electronicPng,
      to: "/category/eletronic-systems",
    },
    {
      name: t("cubesatName", "CubeSat Deployer System"),
      desc: t("cubesatDesc", "Flight-qualified deployment systems designed for reliable CubeSat satellite releases."),
      img: cubesatsPng,
      to: "/category/cubesat-deployer-system",
    },
  ];

  return (
    <PageShell>
      {/* HERO SECTION */}
      <PageHero
        title={t("heroTitle", "Our Technology Verticals")}
        description={t("heroDesc",
          "With a vertical integration, all our projects are designed, manufactured and tested in-house. We can make personalized designs for your needs. Contact us to discuss.",
        )}
        video={heroVideo}
      />
      {/* PRODUCTS SECTION */}
      <CategoryProductGrid products={products} titleMinHeight="62px" descMinHeight="60px" />
    </PageShell>
  );
}
